/**
 * @Description: 用户自定义标签模板信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  TemplateUserModel,
  TemplateUserSearchModel,
  TemplateUserPageSearchModel,
  TemplateUserAddModel,
  TemplateUserUpdateModel,
  TemplateUserViewModel,
  IdsModel
} from '@/model/product/TemplateUserModel'

const baseUrl = Route.product + '/templateUser'

/**
 * 搜索分页数据
 */
export const pageSearchTemplateUser = (param: TemplateUserPageSearchModel) => {
  return https().request<RootObject<PageRespModel<TemplateUserViewModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchTemplateUser = (param: TemplateUserSearchModel) => {
  return https().request<RootObject<TemplateUserModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getTemplateUser = (id: number) => {
  return https().request<RootObject<TemplateUserModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addTemplateUser = (param: TemplateUserAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateTemplateUser = (param: TemplateUserUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeTemplateUser = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveTemplateUser = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
